// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2LIwB","col":"Header_col__1juA5"};